export const TAG_TESTIDS = {
    TAG: 'TAG',
    TAG_LOADING_CONTAINER: 'TAG_LOADING_CONTAINER',
};
